(() => {
  'use strict';
  if (window.AuroreGiftDiscounts) return;
  const source = 'aurore-gift-offer-v1';
  const root = window.Shopify?.routes?.root || '/';
  const url = root + 'cart';
  let pending;
  const variantId = entry => String(entry.var_id || entry.variant_id?.split('/').pop() || '');
  function discountPlan(cart) {
    const offers = [
      { products: { main: 15569821696324, second: 15569821696324, earrings: 15693447823684, keyring: 15615112905028 }, amounts: { second: 9, earrings: 5, keyring: 8 } },
      { products: { main: 15155616121156, second: 15155616121156, earrings: 15693447823684, keyring: 15186693390660 }, amounts: { second: 9, earrings: 5, keyring: 6 } }
    ];
    const plan = new Map();
    for (const { products, amounts } of offers) {
      const mains = cart.items.filter(item => item.quantity > 0 && item.product_id === products.main && item.properties?._aurore_offer_slot === 'main');
      let selected = [];
      for (const main of mains) {
        selected = cart.items.filter(item => item.quantity > 0 && item.properties?._aurore_offer_id === main.properties._aurore_offer_id && products[item.properties._aurore_offer_slot] === item.product_id && amounts[item.properties._aurore_offer_slot]);
        if (selected.length) break;
      }
      const slots = new Set();
      for (const item of selected) {
        const slot = item.properties._aurore_offer_slot;
        if (slots.has(slot)) continue;
        slots.add(slot);
        const var_id = String(item.variant_id), amount = amounts[slot];
        if (!plan.has(var_id) || Number(plan.get(var_id).amount) < amount) plan.set(var_id, { variant_id: 'gid://shopify/ProductVariant/' + var_id, amount: amount.toFixed(2), var_id, source });
      }
    }
    return [...plan.values()];
  }
  function existing(cart) {
    let entries;
    try { entries = JSON.parse(cart.attributes?.mw_discounts || '[]'); } catch { throw new Error('Не успяхме да прочетем отстъпките в количката.'); }
    if (!Array.isArray(entries)) throw new Error('Невалидна настройка на отстъпките.');
    return entries;
  }
  function combine(entries, plan) {
    const base = entries.filter(entry => entry.source !== source);
    for (const entry of entries.filter(entry => entry.source === source)) {
      if (Array.isArray(entry._aurore_saved_discounts)) base.push(...entry._aurore_saved_discounts.filter(saved => saved.source !== source));
    }
    const ids = new Set(plan.map(variantId));
    const result = base.filter(entry => !ids.has(variantId(entry)));
    for (const entry of plan) {
      const saved = base.filter(other => variantId(other) === variantId(entry));
      if (!saved.length) { result.push(entry); continue; }
      const amount = Number(saved[0].amount);
      if (!Number.isFinite(amount) || amount < 0) throw new Error('Не успяхме да съвместим отстъпките в количката.');
      result.push({ ...entry, amount: (Number(entry.amount) + amount).toFixed(2), _aurore_saved_discounts: saved });
    }
    return result;
  }
  async function getCart() {
    const response = await fetch(url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Не успяхме да проверим количката.');
    return response.json();
  }
  async function syncNow(cart) {
    cart = cart || await getCart();
    const plan = discountPlan(cart), previous = existing(cart), desired = combine(previous, plan);
    const changed = JSON.stringify(previous) !== JSON.stringify(desired);
    if (changed) {
      const response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { mw_discounts: JSON.stringify(desired) } }) });
      if (!response.ok) throw new Error('Отстъпката не беше приложена. Опитай отново.');
      cart = await response.json();
    }
    for (const entry of desired.filter(entry => entry.source === source)) {
      const actual = cart.items.filter(item => String(item.variant_id) === entry.var_id).reduce((sum, item) => sum + item.original_line_price - item.final_line_price, 0);
      if (actual + 1 < Math.round(Number(entry.amount) * 100)) throw new Error('Shopify не потвърди намалената цена. Опитай отново.');
    }
    return { cart, changed };
  }
  function sync(cart) {
    if (pending) return pending;
    pending = syncNow(cart).finally(() => { pending = null; });
    return pending;
  }
  window.AuroreGiftDiscounts = { sync, plan: discountPlan };
  if (window.location.pathname.replace(/\/$/, '') !== url.replace(/\/$/, '')) return;
  let timer, running = false;
  async function refresh() {
    if (running) return;
    running = true;
    const button = document.getElementById('checkout'), wasDisabled = button?.disabled;
    if (button) button.disabled = true;
    try {
      const result = await sync();
      if (result.changed) { window.location.reload(); return; }
      document.getElementById('aurore-discount-error')?.remove();
    } catch (error) {
      let box = document.getElementById('aurore-discount-error');
      if (!box) {
        box = document.createElement('p');
        box.id = 'aurore-discount-error';
        box.setAttribute('role', 'alert');
        box.style.cssText = 'padding:12px;background:#fff2e9;color:#81351c';
        document.getElementById('main-cart-footer')?.prepend(box);
      }
      box.textContent = error.message;
    } finally {
      running = false;
      if (button) button.disabled = wasDisabled;
    }
  }
  const queue = () => { clearTimeout(timer); timer = setTimeout(refresh, 450); };
  document.addEventListener('change', event => { if (event.target.matches('input[name="updates[]"]')) queue(); });
  document.addEventListener('click', event => { if (event.target.closest('cart-remove-button,quantity-input')) queue(); });
  const items = document.getElementById('main-cart-items');
  if (items) new MutationObserver(queue).observe(items, { childList: true, subtree: true });
  refresh();
})();
